module.exports = __webpack_public_path__ + "static/media/front.d121fac2.jpg";